import { FORM_ERROR } from 'final-form';
import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';
import { Union } from 'ts-toolbelt';

import { InitialValues, ValidationErrors } from 'forms/types';
import { composeValidators, isBetween, isPresent } from 'forms/validators';
import { Gender } from 'types/graph';

import { HealthBasicsFormValues } from '../form/types';

export const MS_ALZHEIMERS_ERROR =
  "Sorry - we won't be able to get you quotes if you have Multiple Sclerosis or Alzheimer's Disease";

export const getValidator =
  ({ gender }: { gender: Union.Nullable<Gender> }) =>
  ({
    heightInInches,
    weight,
    historyOfTobaccoUse,
    usedInPastYear,
    planningToBeOrPregnant,
    suspendedConviction,
    dwiConviction,
    multipleSclerosis,
    alzheimerDisease,
  }: InitialValues<HealthBasicsFormValues>): ValidationErrors<HealthBasicsFormValues> => {
    const errors: ValidationErrors<HealthBasicsFormValues> = {
      heightInInches: isPresent(heightInInches),
      weight: composeValidators(isPresent, isBetween(10, 999))(weight),
      historyOfTobaccoUse: isPresent(historyOfTobaccoUse),
      suspendedConviction: isPresent(suspendedConviction),
      dwiConviction: isPresent(dwiConviction),
    };

    if (historyOfTobaccoUse) {
      errors.usedInPastYear = isPresent(usedInPastYear);
    }

    if (gender === Gender.Female) {
      errors.planningToBeOrPregnant = isPresent(planningToBeOrPregnant);
    }

    if (multipleSclerosis || alzheimerDisease) {
      errors[FORM_ERROR] = MS_ALZHEIMERS_ERROR;
    }

    return omitBy(errors, isNil);
  };
